import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { colors } from "@/theme";
import { ProductCard } from "@/components/ProductCard";
import { ProductGridSkeleton, EmptyState } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function CollectionDetail() {
  const { id } = useParams();
  const [collection, setCollection] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    api("/collections").then((cs) => setCollection(cs.find((c) => c.id === id) || { name: id }));
    setLoading(true);
    api(`/products?collection=${id}`).then(setProducts).finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="fade-up">
      <div style={{ position: "relative", height: isMobile ? 260 : 380, overflow: "hidden" }}>
        {collection?.image && <img src={collection.image} alt={collection.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(44,41,37,0.15), rgba(44,41,37,0.55))" }} />
        <div className="container-max" style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: isMobile ? "0 16px 28px" : "0 24px 40px" }}>
          <h1 className="font-display" style={{ color: "#FCFBF8", margin: 0, fontSize: isMobile ? 34 : 48, fontWeight: 700 }}>{collection?.name}</h1>
          {collection?.tagline && <p className="font-body" style={{ color: "rgba(252,251,248,0.9)", marginTop: 8 }}>{collection.tagline}</p>}
        </div>
      </div>
      <div className="container-max" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px" }}>
        <div className="eyebrow" style={{ marginBottom: 20 }}><Link to="/collections" style={{ color: colors.mutedText, textDecoration: "none" }}>Collections</Link> / {collection?.name}</div>
        {loading ? <ProductGridSkeleton /> : products.length === 0 ? (
          <EmptyState title="Coming soon" message="Pieces for this collection are on their way." />
        ) : (
          <div className="product-grid">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
        )}
      </div>
    </div>
  );
}
